import { render } from "./Artists.vue?vue&type=template&id=6fd98110"
import script from "./Artists.vue?vue&type=script&lang=js"
export * from "./Artists.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__